import React from 'react';
import RaiseSupport from './RaiseSupport';

// Every tenant-app login — admin, doctor, staff, hospital patient — is a
// RAISER. Tickets are handled on the Super Admin side (Frontend-superadmin-web),
// so there is no admin inbox here any more and nothing to branch on.
const Support = () => (
    <div data-testid="support-router-raise" className="contents">
        <RaiseSupport />
    </div>
);

export default Support;
